import React, { useContext, useEffect } from 'react';
import { Linking, StyleSheet, View } from 'react-native';
import { Helmet } from 'react-helmet';
import AppContext, { AppActions } from '../contexts/App';
import * as ExpoFileLogger from 'expo-file-logger';
import * as SplashScreen from 'expo-splash-screen';
import LayoutContext, { LAYOUTS } from '../contexts/Layout';
import { fetchPage, fetchDomainItemByKey } from '../common/Api';
import { ClassicLayout, ModernLayout } from '../layouts';
import { UmbracoComponentMapping } from '../Mapping';

export const MainView = () => {
    const { state, dispatch } = useContext(AppContext);
    const { layout } = useContext(LayoutContext);

    const followContentLink = async (isExternal, internalKey, externalUrl, refs) => {
        if (isExternal) {
            ExpoFileLogger.log('debug', `followContentLink: external link (${externalUrl})`);

            Linking.openURL(externalUrl);
        } else {
            let page; //= refs[internalKey] || state.action.data?.references[internalKey];

            if (!page) {
                // if (refs) {
                //     page = refs[internalKey];
                // }

                if (!page) {
                    ExpoFileLogger.log('debug', `followContentLink domain item by key (${internalKey})`);
                    const response = await fetchDomainItemByKey(state.settings.websiteSettings.domain, internalKey);

                    if (response && response.item) {
                        page = response.item;
                        refs = response.references;
                    }
                }
            }

            if (page) {
                ExpoFileLogger.log('debug', `followContentLink page rootPath=${page.rootPath}`);

                dispatch({
                    data: {
                        page,
                        references: refs
                    },
                    href: page.rootPath,
                    type: AppActions.NAVIGATE
                });
            }
        }
    };

    const goBack = async () => {
        const href = state.action.href;
        let previousHref = state.action.previousHref;

        if (!previousHref) {
            previousHref = '/';
        }

        ExpoFileLogger.log('debug', `goBack[from: ${href}, to: ${previousHref}]`);

        await fetchPage(dispatch, previousHref);
    };

    const renderEmbeddedScripts = () => {
        return Object.values(state.siteWrapper?.web?.contentItems || {}).map(item => {
            if (item.nodeTypeAlias.equals('reactEmbeddedScript')) {
                const EmbeddedScript = UmbracoComponentMapping.reactEmbeddedScript;

                return <EmbeddedScript {...item} key={item.id} />;
            }

            return null;
        });
    };

    useEffect(() => {
        if (layout.device.os.equals('web')) {
            const { pathname } = window.location;
            const href = state?.action?.href;

            if (pathname?.replaceAll('/', '').equals(href?.replaceAll('/', ''))) {
                return;
            }

            window.history.pushState(state?.action, '', href);
        }
    }, [layout.device.os, state?.action?.href, state.action]);

    useEffect(() => {
        const onPopState = async e => {
            const entry = e.state;

            if (!entry) {
                return;
            }

            dispatch({
                type: AppActions.NAVIGATE,
                data: entry.data,
                href: entry.href
            });
        };

        if (layout.device.os === 'web') {
            window.addEventListener('popstate', onPopState);
        }

        return () => {
            if (layout.device.os === 'web') {
                window.removeEventListener('popstate', onPopState);
            }
        };
    }, [dispatch, layout.device.os]);

    useEffect(() => {
        ExpoFileLogger.log('debug', 'Hiding splash screen');

        (async () => {
            await SplashScreen.hideAsync();
        })();
    }, []);

    useEffect(() => {
        if (layout.device.os.equals('web')) {
            const scriptElement = document.createElement('script');
            
            scriptElement.crossOrigin="anonymous"
            scriptElement.integrity="sha256-/JqT3SQfawRcv/BIHPThkBvs0OEvtFFmqPF/lYI/Cxo="
            scriptElement.src = 'https://code.jquery.com/jquery-3.7.1.min.js';
            scriptElement.type = 'text/javascript';

            document.getElementsByTagName('body')[0].appendChild(scriptElement);
        }
    }, []);

    return (
        <View style={Style.container}>
            <Helmet>
                <meta charset='utf-8' />
                <title>{state.action.data?.page?.title}</title>
                <meta name='keywords' content={state.action.data?.page?.json?.keywords || ''} />
                <link rel='canonical' href={window?.location?.href} />
                {/* Google, Bing, Youtube */}
                <meta name='description' content={state.action.data?.page?.metaDescription} />
                {/* Facebook */}
                <meta property='og:title' content={state.action.data?.page?.title} />
                <meta property='og:type' content='Website' />
                <meta property='og:image' content={`https:${state.action.data?.page?.image?.cdnImagePath}`} />
                <meta property='og:url' content={state.action.data?.page?.rootPath} />
                <meta property='og:description' content={state.action.data?.page?.metaDescription} />
                {/* Twitter */}
                <meta name='twitter:title' content={state.action.data?.page?.title} />
                <meta name='twitter:description' content={state.action.data?.page?.metaDescription} />
                <meta name='twitter:image' content={`https:${state.action.data?.page?.image?.cdnImagePath}`} />
            </Helmet>
            {layout.mode === LAYOUTS.Modern && <ModernLayout followContentLink={followContentLink} goBack={goBack} />}
            {layout.mode !== LAYOUTS.Modern && <ClassicLayout followContentLink={followContentLink} goBack={goBack} />}
            {renderEmbeddedScripts()}
        </View>
    );
};

const Style = StyleSheet.create({
    container: {
        // backgroundColor: '#d3d3d3',
        flex: 1
    }
});
